<p-calendar [formControl]="value" [showIcon]="true"></p-calendar>
